module.exports = __webpack_public_path__ + "static/media/own_blend_icon.f69a3109.svg";